import React from 'react';

import { Button } from '@lt/components';

import CurrencyFormat from 'src/components/CurrencyFormat';
import { formatDateToDayShort } from 'src/utils/dateUtils';
import { pluralizeNights } from 'src/utils/pluralizeUtils';
import { SIMILAR_PACKAGES_CLICK_ON_ALTERNATIVE } from 'checkout/store/constants/similar-packages';
import styled from 'styled-components';
import type { ToursProps } from '@lt/api/dist/methods/similarTours/types';
import type { SimilarPackagesListContainerProps } from './types';

const baseCls = 'similar-packages-list';

const SimilarPackagesList = ({
  start_date: startDate,
  end_date: endDate,
  nights_count: nights,
  room_type: roomType,
  pansion,
  price,
  onClick,
  isMobile,
  operator,
  id,
  request_id: requestId,
}: ToursProps & SimilarPackagesListContainerProps) => {
  const startDateFormatted = formatDateToDayShort(startDate);
  const endDateFormatted = formatDateToDayShort(endDate);
  const pansionText =
    pansion.description || pansion.name || pansion.original_name;
  const paramsForCreatePackage = {
    tour_id: id,
    request_id: requestId,
    type: SIMILAR_PACKAGES_CLICK_ON_ALTERNATIVE,
  };

  return (
    <li className={`${baseCls}__item`}>
      <div className={`${baseCls}__top`}>
        <div className={`${baseCls}__roomtype`}>{roomType}</div>

        <div className={`${baseCls}__date`}>
          <span>{`${startDateFormatted} – ${endDateFormatted}, `}</span>

          <Info isMobile={isMobile}>
            {`${nights} ${pluralizeNights(nights)} · ${pansionText}`}
          </Info>

          <span className={`${baseCls}__operator`}>{operator.name}</span>
        </div>
      </div>

      <Button
        primary
        size="flex"
        onClick={() => onClick(paramsForCreatePackage)}
        className={`${baseCls}__price lt-button-link`}
      >
        <CurrencyFormat value={price} />
      </Button>
    </li>
  );
};

const Info = styled.span<{ isMobile: boolean }>`
  ${({ isMobile }) => isMobile && `display: block;`}
`;

export default SimilarPackagesList;
